import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const phoneNumber = "+966545339911"; 
//   const whatsappUrl = `https://wa.me/${phoneNumber}`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=Hello%2C%20I%27m%20interested%20in%20your%20services`;

  return (
    <div className="floating_btn">
      <a 
        target="_blank" 
        href={whatsappUrl}
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <div className="contact_icon">
          <FaWhatsapp className="whatsapp-icon" />
        </div>
      </a>
      <p className="text_icon">Talk to us?</p>
    </div>
  );
};

export default WhatsAppButton;